<template>
    <div class="nav">
      <div class="nav-con">
        <div class="logo-name" @click="shouye">
          <img src="../../assets/logo-min.png" alt="" />
          <span class="jkbb"> 立 体 宣 教 </span>
        </div>
        <div class="searchBox">
          <!-- <div class="search">
            <input
              type="text"
              v-model="searchKey"
              @keyup.enter="goSearch"
              placeholder="请输入关键词"
            />
            <div class="but" @click="goSearchs">搜索</div>
          </div> -->
          <div class="tologin" @click="toLogin">登录</div>
          <div class="about" @click="aboutUs">关于我们</div>
          <div class="about" @click="Enterpriseregistration">企业注册</div>
        </div>
      </div>
    </div>
</template>

<script>
import axios from "axios";
export default {
    data() {
return {
      page: 0,
      show: true,
      artTypeList: [
        {
          key: "新闻",
          value: 0,
        },
        {
          key: "科普",
          value: 1,
        },
        {
          key: "法规",
          value: 2,
        },
        {
          key: "人文",
          value: 3,
        },
        {
          key: "学术",
          value: 4,
        },
        {
          key: "病例",
          value: 5,
        },
      ],
      typeList: [
        {
          key: "疾病",
          value: 0,
        },
        {
          key: "文章",
          value: 1,
        },
        {
          key: "语音",
          value: 2,
        },
        {
          key: "药品",
          value: 3,
        },
        {
          key: "医生",
          value: 4,
        },
        {
          key: "团队",
          value: "5",
        },
      ],
      typeKey: 0,
      artTypeKey: 0,
      switchType: 1,
      styleKey: false,
      token: "",
      searchKey: "",
      hotKey: [
        [
          {
            value: "高血压",
            key: "gxy",
          },
          {
            value: "高血压",
            key: "gxy",
          },
          {
            value: "高血压",
            key: "gxy",
          },
        ],
        [
          {
            value: "高血压",
            key: "gxy",
          },
          {
            value: "高血压",
            key: "gxy",
          },
          {
            value: "高血压",
            key: "gxy",
          },
        ],
      ],
      newList: [],
      newList1: [],
      newList2: [],
      list0: [],
      list1: [],
      list2: [],
      list3: [],
      list4: [],
      list5: [],
      list6: [],
      list7: [],
      list8: [],
      list9: [],
      list10: [],
      orgList: [],
    };
    },
    methods:{
      Enterpriseregistration () {
        this.$router.push({
          name: "EnterpriseRegistration",
        });
      },
     goSearchs() {
          this.$emit('goSearch')
        // this.$parent.goSearch()
    //          console.log(4444444)
    //   var that = this,
    //     key = that.searchKey;
    //   if (key == "") {
    //     that.styleKey = false;
    //   } else {
    //     // that.({ styleType: '1', list0: [], list1: [], list2: [], list3: [], list4: [], page0: 0, page1: 0, page2: 0, page3: 0, page4: 0 })
    //     that.styleKey = true;
    //     that.list0 = [];
    //     that.list1 = [];
    //     that.list2 = [];
    //     that.list3 = [];
    //     that.list4 = [];
    //     that.list5 = [];
    //     that.list6 = [];
    //     that.list7 = [];
    //     that.list8 = [];
    //     that.list9 = [];
    //     that.list10 = [];
    //     that.getSearchArt(key);
    //     that.getSearchIll(key);
    //     that.getSearchMed(key);
    //     that.getSearchDoc(key);
    //     that.getSearchVoice(key);
    //     that.getOrgList(key);
    //     that.getNewsArt(key);
    //     that.getDocArt(key);
    //     that.getLawArt(key);
    //     that.getHumArt(key);
    //     that.getLearArt(key);
    //     that.getCaseArt(key);
    //   }
    // },
    //     getNewsArt(key) {
    //   var that = this,
    //     page = 0,
    //     token = that.token,
    //     data = {};
    //   axios
    //     .get(
    //       "https://so.lotusdata.com/search/?query=" +
    //         key +
    //         "&type=new_article_news&page_count=20&from=" +
    //         page,
    //       {
    //         headers: { Authorization: token },
    //       }
    //     )
    //     .then((res) => {
    //       if (res.status == 200) {
    //         var list = res.data,
    //           arr = page == 0 ? [] : that.data.list5;
    //         if (list.length == 0) {
    //           list[0] = { names: "没有更多内容了" };
    //         }
    //         that.list5 = list;
    //       } else {
    //       }
    //     });
    // },
    // getDocArt(key) {
    //   var that = this,
    //     page = 0,
    //     token = that.token,
    //     data = {};
    //   axios
    //     .get(
    //       "https://so.lotusdata.com/search/?query=" +
    //         key +
    //         "&type=new_article_doctor&page_count=20&from=" +
    //         page,
    //       {
    //         headers: { Authorization: token },
    //       }
    //     )
    //     .then((res) => {
    //       if (res.status == 200) {
    //         var list = res.data,
    //           arr = page == 0 ? [] : that.data.list6;
    //         if (list.length == 0) {
    //           list[0] = { names: "没有更多内容了" };
    //         }
    //         that.list6 = list;
    //       } else {
    //       }
    //     });
    // },
    // getLawArt(key) {
    //   var that = this,
    //     page = 0,
    //     token = that.token,
    //     data = {};
    //   axios
    //     .get(
    //       "https://so.lotusdata.com/search/?query=" +
    //         key +
    //         "&type=new_article_law&page_count=20&from=" +
    //         page,
    //       {
    //         headers: { Authorization: token },
    //       }
    //     )
    //     .then((res) => {
    //       if (res.status == 200) {
    //         var list = res.data,
    //           arr = page == 0 ? [] : that.data.list7;
    //         if (list.length == 0) {
    //           list[0] = { names: "没有更多内容了" };
    //         }
    //         that.list7 = list;
    //       } else {
    //       }
    //     });
    // },
    // getHumArt(key) {
    //   var that = this,
    //     page = 0,
    //     token = that.token,
    //     data = {};
    //   axios
    //     .get(
    //       "https://so.lotusdata.com/search/?query=" +
    //         key +
    //         "&type=new_article_humanity&page_count=20&from=" +
    //         page,
    //       {
    //         headers: { Authorization: token },
    //       }
    //     )
    //     .then((res) => {
    //       if (res.status == 200) {
    //         var list = res.data,
    //           arr = page == 0 ? [] : that.data.list8;
    //         if (list.length == 0) {
    //           list[0] = { names: "没有更多内容了" };
    //         }
    //         that.list8 = list;
    //       } else {
    //       }
    //     });
    // },
    // getLearArt(key) {
    //   var that = this,
    //     page = 0,
    //     token = that.token,
    //     data = {};
    //   axios
    //     .get(
    //       "https://so.lotusdata.com/search/?query=" +
    //         key +
    //         "&type=new_article_learning&page_count=20&from=" +
    //         page,
    //       {
    //         headers: { Authorization: token },
    //       }
    //     )
    //     .then((res) => {
    //       if (res.status == 200) {
    //         var list = res.data,
    //           arr = page == 0 ? [] : that.data.list9;
    //         if (list.length == 0) {
    //           list[0] = { names: "没有更多内容了" };
    //         }
    //         that.list9 = list;
    //       } else {
    //       }
    //     });
    // },
    // getCaseArt(key) {
    //   var that = this,
    //     page = 0,
    //     token = that.token,
    //     data = {};
    //   axios
    //     .get(
    //       "https://so.lotusdata.com/search/?query=" +
    //         key +
    //         "&type=new_article_case&page_count=20&from=" +
    //         page,
    //       {
    //         headers: { Authorization: token },
    //       }
    //     )
    //     .then((res) => {
    //       if (res.status == 200) {
    //         var list = res.data,
    //           arr = page == 0 ? [] : that.data.list10;
    //         if (list.length == 0) {
    //           list[0] = { names: "没有更多内容了" };
    //         }
    //         that.list10 = list;
    //       } else {
    //       }
    //     });
    // },
    // getOrgList(key) {
    //   var that = this,
    //     page = 0,
    //     token = that.token;
    //   axios
    //     .get(
    //       "https://api.lotusdata.com/v1/organization/olistbytype?key=" +
    //         key +
    //         "&start=" +
    //         page +
    //         "&limit=20&dtype=1",
    //       {
    //         headers: { Authorization: token },
    //       }
    //     )
    //     .then((res) => {
    //       if (res.data.code == "0" && res.data.data != null) {
    //         that.orgList = res.data.data.map((ele) => {
    //           return {
    //             id: ele.Organizationid,
    //             src: ele.Logopic,
    //             name: ele.Name,
    //             type: ele.Type,
    //           };
    //         });
    //       }
    //     });
    // },
    // getSearchArt(key) {
    //   var that = this,
    //     page = 0,
    //     token = that.token,
    //     get_url =
    //       "https://so.lotusdata.com/search/?query=" +
    //       key +
    //       "&type=doctor_material&page_count=20&from=" +
    //       page;
    //   axios
    //     .get(get_url, { headers: { Authorization: token } })
    //     .then(function (res) {
    //       if (res.status == 200) {
    //         if (res.data != null && res.data.length != 0) {
    //           var list = res.data,
    //             arr = page == 0 ? [] : that.data.list0;
    //           that.list0 = list;
    //         } else {
    //           that.list0 = [{ names: "没有更多数据" }];
    //         }
    //       } else {
    //         that.list0 = [{ names: "数据获取失败" }];
    //       }
    //     });
    // },
    // getSearchIll(key) {
    //   var that = this,
    //     page = 0,
    //     token = that.token,
    //     get_url =
    //       "https://so.lotusdata.com/search/?query=" +
    //       key +
    //       "&type=disease_ymp&page_count=20&from=" +
    //       page;
    //   axios
    //     .get(get_url, { headers: { Authorization: token } })
    //     .then(function (res) {
    //       if (res.status == 200) {
    //         if (res.data != null && res.data.length != 0) {
    //           var list = res.data,
    //             arr = page == 0 ? [] : that.data.list2;
    //           that.list2 = list;
    //         } else {
    //           that.list2 = [{ names: "没有更多数据" }];
    //         }
    //       } else {
    //         that.list2 = [{ names: "数据获取失败" }];
    //       }
    //     });
    // },
    // getSearchMed(key) {
    //   var that = this,
    //     page = 0,
    //     token = that.token,
    //     get_url =
    //       "https://so.lotusdata.com/search/?query=" +
    //       key +
    //       "&type=all_drug_instructions&page_count=20&from=" +
    //       page;
    //   axios
    //     .get(get_url, { headers: { Authorization: token } })
    //     .then(function (res) {
    //       if (res.status == 200) {
    //         if (res.data != null && res.data.length != 0) {
    //           var list = res.data,
    //             arr = page == 0 ? [] : that.data.list1;
    //           that.list1 = list;
    //         } else {
    //           that.list1 = [{ names: "没有更多数据" }];
    //         }
    //       } else {
    //         that.list1 = [{ names: "数据获取失败" }];
    //       }
    //     });
    },
    getSearchDoc(key) {
      var that = this,
        token = that.token,
        start = 0,
        get_url =
          "https://so.lotusdata.com/search/?query=" +
          key +
          "&type=doctor_info1&page_count=20&from=" +
          start;
      axios
        .get(get_url, { headers: { Authorization: token } })
        .then(function (res) {
          if (res.status == 200 && res.data.length != 0) {
            var resData = res.data,
              Arr = start == 0 ? [] : that.list3;
            for (var i = 0; i < resData.length; i++) {
              if (resData[i]._source.workingunit.length > 10) {
                resData[i]._source.workingunit =
                  resData[i]._source.workingunit.substr(0, 6) + "...";
              }
              Arr.push({
                src:
                  resData[i]._source.idphoto == ""
                    ? "http://sxbjxh.oss-cn-shanghai.aliyuncs.com/upload/men.jpg"
                    : resData[i]._source.idphoto,
                name: resData[i]._source.name,
                docId: resData[i]._source.doc_id,
                position: resData[i]._source.dutyname,
                hospital: resData[i]._source.workingunit,
                department: resData[i]._source.deptname,
              });
            }
            that.list3 = Arr;
          } else if (res.data.data == null) {
            that.list3 = [{ name: "没有更多数据" }];
          }
        });
    },
    getSearchVoice(key) {
      var that = this,
        page = 0,
        token = that.token,
        get_url =
          "https://so.lotusdata.com/search/?query=" +
          key +
          "&type=voice&page_count=20&from=" +
          page;
      axios
        .get(get_url, { headers: { Authorization: token } })
        .then(function (res) {
          if (res.status == 200) {
            if (res.data != null && res.data.length != 0) {
              var list = res.data,
                arr = page == 0 ? [] : that.data.list4;
              that.list4 = list;
            } else {
              that.list4 = [{ names: "没有更多数据" }];
            }
          } else {
            that.list4 = [{ names: "数据获取失败" }];
          }
        });
    },
    toLogin() {
      location.href = "https://login.litixuanjiao.com/login";
    },
     aboutUs() {
      this.$router.push({
        path: "/aboutUs",
      });
    },
     shouye(){
      this.$router.push({
        path: "/phonePage",
      });
    }
    }


}

</script>

<style scoped lang="less">
 .searchBox {
        float: right;
      }
 .nav {
    color: #fff;
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background-color: #495060;
    position: fixed;
    top: 0;
    z-index: 20;
    .nav-con {
      width: 900px;
      margin: 0 auto;
      .search {
        display: inline-block;
        width: 300px;
        line-height: 35px;
        height: 50px;
        input {
          width: 75%;
          height: 70%;
          padding: 8px;
          color: #000;
          font-size: 14px;
          border: 1px solid #dddddd;
          box-sizing: border-box;
          border-bottom-left-radius: 3px;
          border-top-left-radius: 3px;
        }
        .but {
          cursor: pointer;
          display: inline-block;
          vertical-align: top;
          color: #fff;
          width: 55px;
          height: 70%;
          background-color: #0084ff;
          border-radius: 3px;
        }
      }
      .logo-name {
        height: 50px;
        line-height: 50px;
        float: left;
        img {
          height: 50px;
        }
        .jkbb {
          font-size: 18px;
          display: inline-block;
          vertical-align: top;
        }
      }
      .searchBox {
        float: right;
      }
      .tologin {
        cursor: pointer;
        display: inline-block;
        width: 100px;
        vertical-align: middle;
        line-height: 35px;
        border-radius: 3px;
        height: 35px;
        background-color: #0084fe;
      }
      .about {
        cursor: pointer;
        display: inline-block;
        line-height: 35px;
        color: #fff;
        height: 35px;
        margin-left: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/pcpage/head.vue